module.exports = __webpack_public_path__ + "25ffb785c6a56969f49f016d96c56f86.pdf";